export default __webpack_public_path__ + "static/media/facility_03_4.9d5da6f2.png";